import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}


const _getTotals = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/totals?${params}`,
    config
  )
}

const _getTransactions = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/transactions-metrics?${params}`,
    config
  )
}

const _getMppOpenRate = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/mpp-open-rate?${params}`,
    config
  )
}

const _getTotalsByPeriod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/totals-by-period?${params}`,
    config
  )
}

const _getBroadcastsSentInPeriod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/sent-in-period?${params}`,
    config
  )
}

const _getBroadcastErrors = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/errors?${params}`,
    config
  )
}

// Actividad de receptores completa (mismo filtro que la lista) como CSV o
// Excel. Blob: como texto se pierde el BOM y Excel lee mal las tildes.
const _getBroadcastReceptorsActivityExport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    },
    responseType: 'blob'
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/receptors-activity/export?${params}`,
    config
  )
}

const _getBroadcastReceptorsActivity = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/receptors-activity?${params}`,
    config
  )
}

const _getBroadcastsUsage = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/usage?${params}`,
    config
  )
}

const _getBroadcastItemsRevenueByPeriod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }
  
  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/items-revenue-by-period?${params}`,
    config
  )
}

const _getOpenClickByHour = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/open-click-by-hour?${params}`,
    config
  )
}

const _getTopClientsDevices = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/top-clients-devices?${params}`,
    config
  )
}

export default {
  getTotals: _getTotals,
  getTransactions: _getTransactions,
  getMppOpenRate: _getMppOpenRate,
  getTotalsByPeriod: _getTotalsByPeriod,
  getOpenClickByHour: _getOpenClickByHour,
  getTopClientsDevices: _getTopClientsDevices,
  getBroadcastsSentInPeriod: _getBroadcastsSentInPeriod,
  getBroadcastErrors: _getBroadcastErrors,
  getBroadcastReceptorsActivity: _getBroadcastReceptorsActivity,
  getBroadcastReceptorsActivityExport: _getBroadcastReceptorsActivityExport,
  getBroadcastsUsage: _getBroadcastsUsage,
  getBroadcastItemsRevenueByPeriod: _getBroadcastItemsRevenueByPeriod
}